import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts'
import periodCompareColors from '../../../helpers/compareHelpers/periodCompareColors'
import { CHART_MARK_STROKE, CHART_MARK_STROKE_WIDTH } from '../../../helpers/chartPalette'
import ChartDataTable from '../../graphData/ChartDataTable'
import { wideTable } from '../../../helpers/dataHelpers/chartDataTable'

// AI-CONTEXT: See docs/features/compare-two-periods.md
// Grouped-bar compare view for a single-moment bar chart: two bars per category
// (primary period A vs compare period B), colour-coded teal/coral. Chosen
// instead of ComparisonFrame's small multiples when the chart is a
// single-moment bar — grouping the two periods per category reads better than
// two separate charts. Same recharts grouped-bar shape as CompareSection.
//
// Presentational: the caller aligns the two periods' category series with
// mergeCategorySeries() and passes the rows in. A null value simply renders no
// bar for that period/category (not a misleading zero).

/**
 * @param {object} props
 * @param {Array<{name: string, a: number|null, b: number|null}>} props.data - Grouped rows (see mergeCategorySeries)
 * @param {string} props.labelA - Primary period series label (legend/tooltip)
 * @param {string} props.labelB - Compare period series label
 * @param {number} [props.height] - Chart height in px (default 240)
 * @returns {JSX.Element}
 */
const GroupedBarCompare = ({ data, labelA, labelB, height = 240 }) => {
    const rows = Array.isArray(data) ? data : []
    const hasValues = rows.some(r => r.a !== null || r.b !== null)

    if (!hasValues) {
        return <p className='analysis-card-empty'>Geen resultaten gevonden</p>
    }

    return (
        <div className='grouped-bar-compare'>
            <ResponsiveContainer width='100%' height={height}>
                <BarChart data={rows} margin={{ top: 10, right: 20, bottom: 10, left: 0 }}>
                    <CartesianGrid strokeDasharray='3 3' />
                    <XAxis dataKey='name' />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Bar dataKey='a' name={labelA} fill={periodCompareColors.A} stroke={CHART_MARK_STROKE} strokeWidth={CHART_MARK_STROKE_WIDTH} />
                    <Bar dataKey='b' name={labelB} fill={periodCompareColors.B} stroke={CHART_MARK_STROKE} strokeWidth={CHART_MARK_STROKE_WIDTH} />
                </BarChart>
            </ResponsiveContainer>
            {/* Per categorie de waarde in beide periodes, voor de kopie. */}
            <ChartDataTable table={wideTable(rows.map(r => ({ name: r.name, [labelA]: r.a, [labelB]: r.b })), [labelA, labelB], 'Categorie')} />
        </div>
    )
}

export default GroupedBarCompare
